import { ErrorBoundary } from "react-error-boundary"
import { Outlet } from "react-router-dom";
import { GlobalInviteUserDialog } from '@/components/dialogs/GlobalInvitationDialog.jsx'
import { useDashboardLoader } from '@/hooks/useDashboardLoader.jsx'
import { toggleInvitationDialog, useInviteMember } from '@/hooks/useInviteMember.jsx'
import { MainLoader } from '@/components/loader/MainLoader.jsx'
import { NavBar } from '@/layouts/dashboard/nav/NavBar.jsx'
import { useState } from 'react'
import { handleError } from '@/services/errorHandler.js'
import { AppErrorBoundary } from '@/components/app-error-boundry/AppErrorBoundary.jsx'
import { useAuthContext } from '@/context-state/AuthContext.jsx'

export default function DashboardLayout() {

    const { user } = useAuthContext()
    const isLoading = useDashboardLoader()
    const isInviteMemberDialogOpen = useInviteMember()
    const [isNavbarExpanded, setIsNavbarExpanded] = useState(user.testUser ? false : true)

    return (
        <div className="h-screen">
            <NavBar
                isExpanded={isNavbarExpanded}
                setIsExpanded={setIsNavbarExpanded}
            />
            <main className={`transition-all duration-300 h-full bg-main-surface bg-center bg-cover bg-no-repeat overflow-hidden relative ${isNavbarExpanded ? 'pl-72' : 'pl-12'} `}>

                {/* Dashboard Global Components */}
                {isLoading && <MainLoader className="absolute z-[9999] top-0 left-0 bg-background/70 h-full"/>}

                <GlobalInviteUserDialog open={isInviteMemberDialogOpen} closeDialog={() => toggleInvitationDialog(false)}/>
                {/* Dashboard Global Components Ends */}

                <div className="p-4 px-4 h-full overflow-y-scroll">
                    <ErrorBoundary
                        fallback={<AppErrorBoundary />}
                        onError={(e) => handleError({ error: e, context: 'ErrorBoundary' })}
                    >
                        <Outlet/>
                    </ErrorBoundary>

                </div>

            </main>
            {/* <DashboardFooter /> */}
        </div>
    )
}
